import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from '../../core/base.component';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {AuthService} from '../../core/security/auth.service';
import {appColors} from '../../core/styles/colors';
import {ReportsService} from '../reports.service';
import {CallLogsGridComponent} from '../call-logs/call-logs-grid.component';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import {GroupsDashboardService} from './groups-dashboard.service';
import {GroupsTotalModel} from '../../api/models/groups-total-model';
import {GroupsGrandTotalModel} from '../../api/models/groups-grand-total-model';
import {DateTime, Settings} from 'luxon';
import {SelectedFilterValuesModel} from '../../dialogs/grid-filter/selected-filter-values.model';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import * as _ from 'lodash';
import {DateRangeService} from '../../core/services/date-range.service';
import {MatDialog} from '@angular/material/dialog';
import {GroupsSummaryFilterDialogComponent} from '../shared/groups-summary-filter-dialog.component';
import {MatGroupsDashboardZoomDialogComponent} from '../shared/charts/mat-groups-dashboard-zoom-dialog.component';
import { GroupCallByTime, ChartGroupsByTimeComponent } from '../shared/charts/chart-groups-by-time.component';
import { FlexModule } from '@angular/flex-layout';
import { NgIf } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { DashboardCardComponent } from '../shared/dashboard-card.component';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { ChartByGroupsComponent } from '../shared/charts/chart-by-groups.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-agent-groups-dashboard',
    templateUrl: './agent-groups-dashboard.component.html',
    styleUrls: ['./agent-groups-dashboard.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressBar,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        DashboardCardComponent,
        MatCard,
        MatCardContent,
        ChartByGroupsComponent,
        ChartGroupsByTimeComponent,
        MatCardTitle,
        MatIconButton,
        MatIcon,
        CallLogsGridComponent,
    ],
})
export class AgentGroupsDashboardComponent extends BaseComponent implements OnInit, OnDestroy {

  filterChangeEvent = new EventEmitter<any>();
  selectedFilterChange = new EventEmitter<SelectedFilterValuesModel[]>();

  selectedFilter: SelectedFilterValuesModel[] = new Array<SelectedFilterValuesModel>();
  filterOptions: FilterOptionModel[] = [];
  additionalFilter: any = {};

  colors = appColors;
  dashboardData: GroupsTotalModel = {} as GroupsTotalModel;
  grandTotals: GroupsGrandTotalModel = {} as GroupsGrandTotalModel;
  groupsSeriesTotals: any = [];
  timeSeriesTotals: GroupCallByTime[] = [];
  timeSeriesType: 'line' | 'bar' = 'line';
  groupsSeriesType = 'column';

  cubicVisibility = {
    totalCalls: true,
    missedCalls: true,
    answeredByUser: true,
    users: true,
    avgTalkDuration: true,
    avgWaitDuration: true,
  };

  isLoading = true;

  @ViewChild('callLogsGrid', {static: true}) callLogsGrid: CallLogsGridComponent;

  constructor(public reportsService: ReportsService, public reportApiService: ReportsApiService,
              public dashboardService: GroupsDashboardService,
              public dateRangeService: DateRangeService,
              public dialog: MatDialog,
              route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService) {
    super(route, headerService, titleService, authService);
  }

  ngOnInit() {
    super.ngOnInit();
    console.log('my on init');

    this.headerService.hideSearchInput();

    if (this.reportsService.accountsLookup?.length > 0) {
      this.initFilterOptions();
    } else {
      this.reportsService.lookupUpdatedEvent.subscribe(() => {
        this.initFilterOptions();
      });
    }

    this.filterChangeEvent.subscribe(async (filter) => {
      console.log(filter);
      this.isLoading = true;
      const response = await this.reportApiService.groupsDashboardGetGroupsDashboardData({
        body: {
          domain: this.reportsService.selectedDomain || '',
          startDate: filter.startDate,
          endDate: filter.endDate,
          extensions: filter.groupAccounts
        }
      }).toPromise();

      if (response) {
        this.dashboardService.dashboardData = response;
        this.dashboardData = this.dashboardService.dashboardData;

        this.mapData();
      }
      this.isLoading = false;
    });
  }

  mapData() {
    this.dashboardData = this.dashboardService.dashboardData;

    const gTotals = this.dashboardData.grandTotals ? this.dashboardData.grandTotals[0] : null;
    this.grandTotals = gTotals || {
      totalCalls: 0,
      missedCalls: 0,
      answeredByUser: 0,
      users: [],
      totalHoldDuration: 0,
      totalCallDuration: 0,
      avgTalkDuration: 0,
      avgWaitDuration: 0,
    };
    this.grandTotals.users = this.grandTotals.users.filter(x => !!x);

    if (!this.dashboardData.totalsByGroup) {
      this.dashboardData.totalsByGroup = [];
    }
    this.groupsSeriesTotals = this.dashboardData.totalsByGroup.map((item) => {
      item.users = item.users.filter(x => !!x);

      return {
        extension: item._id,
        totalCalls: item.totalCalls,
        missedCalls: item.missedCalls,
        answeredByUser: item.answeredByUser,
        usersCount: item.users.length,
        avgTalkDuration: item.avgTalkDuration,
        avgWaitDuration: item.avgWaitDuration,
        totalHoldDuration: item.totalHoldDuration,
        totalCallDuration: item.totalCallDuration,
      };
    });
    this.sortUsersData();

    let maxDate = DateTime.fromISO('1790-01-01');
    if (!this.dashboardData.totalsByTime) {
      this.dashboardData.totalsByTime = [];
    }
    this.timeSeriesTotals = this.dashboardData.totalsByTime.map((item: any) => {

      const key = item._id;
      const localDateTime =
        DateTime
          .utc(key.year, key.month, key.day, key.hour, key.minutes)
          .setZone(Settings.defaultZone);

      if (localDateTime > maxDate) {
        maxDate = localDateTime;
      }

      item.users = item.users.filter(x => !!x);

      return {
        date: localDateTime.toJSDate(), // DateUtils.localDateFromDateTime(localDateTime),
        answeredCalls: item.answeredByUser,
        missedCalls: item.missedCalls,
        activeAgents: item.users.length,
        /*totalCalls: item.totalCalls,
        answeredByUser: item.answeredByUser,
        usersCount: item.users.length,
        totalHoldDuration: item.totalHoldDuration,
        totalCallDuration: item.totalCallDuration,*/
      };
    });
  }

  sortUsersData() {
    const type = this.dashboardService.selectedFilterType.action;
    this.groupsSeriesTotals.sort((left, right) => {
      let leftTotal, rightTotal;
      if (type === 0) {
        leftTotal = left.totalCalls;
        rightTotal = right.totalCalls;
      } else if (type === 1) {
        leftTotal = left.answeredByUser;
        rightTotal = right.answeredByUser;
      } else if (type === 2) {
        leftTotal = left.missedCalls;
        rightTotal = right.missedCalls;
      } else if (type === 3) {
        leftTotal = left.usersCount;
        rightTotal = right.usersCount;
      } else {
        leftTotal = left.totalCalls;
        rightTotal = right.totalCalls;
      }
      return leftTotal === rightTotal ? 0 : (leftTotal > rightTotal ? -1 : 1);
    });
  }

  usersChartTitle() {
    let title = this.dashboardService.selectedFilterType.text;
    if (this.dashboardService.selectedFilterType.action === 4 && this.groupsSeriesType === 'pie') {
      title = 'Avg. Talk Duration';
    }
    if (this.dashboardService.selectedFilterType.action === 5 && this.groupsSeriesType === 'pie') {
      title = 'Avg. Wait Duration';
    }
    return title;
  }

  onFilterTypeChange($event) {
    if ($event === this.dashboardService.selectedFilterType.action) {
      this.dashboardService.selectedFilterType = this.dashboardService.filterTypes[6];
    } else {
      this.dashboardService.selectedFilterType = this.dashboardService.filterTypes[$event];
    }
    this.sortUsersData();
    console.log($event, this.dashboardService.selectedFilterType);

    let shouldUpdateLogs = true;
    // filter call logs
    const statuses: string[] = [];
    switch (this.dashboardService.selectedFilterType.action) {
      case 0:
        break;
      case 1:
        statuses.push('Answered');
        break;
      case 2:
        statuses.push('Missed');
        statuses.push('Mailbox');
        break;
      case 3:
        statuses.push('Answered');
        break;
      case 4:
        shouldUpdateLogs = false;
        break;
      case 5:
        shouldUpdateLogs = false;
        break;
      default:
    }

    if (shouldUpdateLogs) {
      const callLogsFilter = this.callLogsGrid.additionalFilter || {};
      callLogsFilter.statuses = statuses.length > 0 ? statuses : null;
      this.filterChangeEvent.emit(callLogsFilter);
    }
  }

  async onExportClick() {
    await this.callLogsGrid.onExportClick();
  }

  onSeriesChartZoomClick() {
    this.dialog.open(MatGroupsDashboardZoomDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        chartData: this.timeSeriesTotals,
        filterType: this.dashboardService.selectedFilterType,
        dialogTitle: `${this.dashboardService.selectedFilterType.text} Breakdown by Time`,
        timeSeriesType: this.timeSeriesType,
        showChartByTime: true,
        startDate: this.additionalFilter.startDate,
        endDate: this.additionalFilter.endDate,
      }
    });
  }

  onUserChartZoomClick() {
    this.dialog.open(MatGroupsDashboardZoomDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        chartData: this.groupsSeriesTotals,
        filterType: this.dashboardService.selectedFilterType,
        dialogTitle: `${this.usersChartTitle()} By Group`,
        groupsSeriesType: this.groupsSeriesType
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  openFilterDialog() {
    console.log('open filter dialog');
    const dialogRef = this.dialog.open(GroupsSummaryFilterDialogComponent, {
      width: '500px',
      height: '90%',
      data: {
        filter: this.selectedFilter,
        hideHuntGroups: true
      }
    });

    dialogRef.afterClosed().subscribe(async (result: SelectedFilterValuesModel[]) => {
      if (result) {
        this.selectedFilterChange.emit(result);
      }
    });
  }

  onSelectedItemsChanged($event: SelectedFilterValuesModel[]) {
    this.selectedFilter = $event;
  }

  onFilterChanged(filter: any) {
    let accounts = [];

    if (filter['agentGroup']) {
      accounts = _.union(accounts, filter['agentGroup']);
      filter['agentGroup'] = undefined;
    }
    if (filter['huntGroup']) {
      accounts = _.union(accounts, filter['huntGroup']);
      filter['huntGroup'] = undefined;
    }

    filter['groupAccounts'] = accounts;
    filter['types'] = ['isGroup'];

    this.additionalFilter = filter;
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      /*{
        filterKey: 'groupTypes',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Agents Group',
        value: 'acd',
        searchText: 'Type: Agents Group',
      },
      {
        filterKey: 'groupTypes',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Hunt Group',
        value: 'hunt',
        searchText: 'Type: Hunt Group',
      },*/
    ];

    if (this.reportsService.groupsLookup.length > 0) {
      for (const item of this.reportsService.groupsLookup) {
        this.filterOptions.push({
          filterKey: 'agentGroup',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Agent Group',
          displayValue: item.text,
          value: item.value,
          searchText: `Agent Group: ${item.text}`,
        });
      }
    }

    /*if (this.reportsService.huntGroupsLookup.length > 0) {
      for (const item of this.reportsService.huntGroupsLookup) {
        this.filterOptions.push({
          filterKey: 'huntGroup',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Hunt Group',
          displayValue: item.text,
          value: item.value,
          searchText: `Hunt Group: ${item.text}`,
        });
      }
    }*/
  }
}
